import { isNil } from 'lodash/fp';

const REGEXP = /[-_.]/g;
const REPLACEMENT = '$&\u200B';

export function addWordBreaks(value: string) {
    if (isNil(value)) {
        return '';
    }

    return value.replaceAll(REGEXP, REPLACEMENT);
}
